import { FunctionComponent } from 'react';

import SolutionGraphs from 'components/content/sections/SolutionGraphs';
import Header from 'components/layout/Header';
import { HeaderStyles, HeaderTextPositions } from 'components/layout/Header/types';
import LayoutContainer from 'components/layout/LayoutContainer/component';

import StyledComponent from './styles';
import { Props } from './types';

const PageHomeSectionSolution: FunctionComponent<Props> = ({ translations }) => {
    return (
        <StyledComponent className="page-home-section-solution">
            <LayoutContainer className="solutions">
                <Header
                    className="header-solutions"
                    title={translations?.title}
                    style={HeaderStyles.Dark}
                    textPosition={HeaderTextPositions.Center}
                />
                <SolutionGraphs
                    graphElements={translations?.elements}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageHomeSectionSolution;